import { Box, Typography, Paper, Divider } from '@mui/material'

const fieldLabels = {
  firstName: 'First Name',
  surname: 'Surname',
  nhiNumber: 'NHI Number',
  dob: 'Date of Birth',
  countryOfBirth: 'Country of Birth',
  occupation: 'Occupation',
  address: 'Address',
  suburb: 'Suburb',
  city: 'City',
  postcode: 'Postcode',
  address2: 'Secondary Address',
  mobileNumber: 'Mobile Number',
  alternativeNumber: 'Alternative Contact Number',
  email: 'Email',
  interpreterNeeded: 'Interpreter Needed',
  motherEthnicity1: "Mother's Ethnicity (1)",
  motherEthnicity2: "Mother's Ethnicity (2)",
  motherEthnicity3: "Mother's Ethnicity (3)",
  babyEthnicity: "Baby's Ethnicity",
  specialDietaryNeeds: 'Special Dietary Needs',
  drugAllergies: 'Drug Allergies',
  hasInsurance: 'Health Insurance',
  insuranceCompany: 'Insurance Company',
  insuranceType: 'Insurance Type',
  isNZResident: 'NZ Resident',
  roomOptions: 'Room Options',
  additionalCommentsRequirements: 'Additional Comments/Requirements',
  carerType: 'Carer Type',
  carerFirstName: "Carer's First Name",
  carerSurname: "Carer's Surname",
  postnatalMidwifeName: 'Name of Postnatal Midwife',
  expectedDueDate: 'Expected Due Date',
  proposedPlaceOfBirth: 'Proposed Place of Birth',
  gravida: 'Gravida',
  parity: 'Parity',
  placeOfDelivery: 'Place of Delivery',
  emergencyFirstName: 'Emergency Contact First Name',
  emergencySurname: 'Emergency Contact Surname',
  emergencyRelationship: "Emergency Contact's Relationship",
  emergencyMobileNumber: 'Emergency Mobile Number',
  alternativeContactNumber: 'Alternative Contact Number',
  emergencyContactAddress: 'Emergency Contact Address'
}

const sections = {
  'Personal Details': ['firstName', 'surname', 'nhiNumber', 'dob', 'countryOfBirth', 'occupation'],
  'Address Information': ['address', 'suburb', 'city', 'postcode', 'address2'],
  'Contact Details': ['mobileNumber', 'alternativeNumber', 'email'],
  'Interpreter': ['interpreterNeeded'],
  'Ethnicity & Background': ['motherEthnicity1', 'motherEthnicity2', 'motherEthnicity3', 'babyEthnicity'],
  'Dietary & Allergies': ['specialDietaryNeeds', 'drugAllergies'],
  'Health Insurance': ['hasInsurance', 'insuranceCompany', 'insuranceType'],
  'Birthcare Service Selection': ['isNZResident', 'roomOptions', 'additionalCommentsRequirements'],
  'Lead Maternity Carer': ['carerType', 'carerFirstName', 'carerSurname', 'postnatalMidwifeName', 'expectedDueDate', 'proposedPlaceOfBirth', 'gravida', 'parity'],
  'Emergency Contact': ['emergencyFirstName', 'emergencySurname', 'emergencyRelationship', 'emergencyMobileNumber', 'alternativeContactNumber', 'emergencyContactAddress']
}

const formatValue = (field, value) => {
  if (!value) return 'N/A'
  if (['dob', 'expectedDueDate'].includes(field)) return value.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3-$2-$1') // date fields
  if (['interpreterNeeded', 'isNZResident', 'hasInsurance'].includes(field)) return value === 'true' ? 'Yes' : 'No' // boolean fields
  return value
}

function SummaryPage ({ formData }) {
  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
      <Typography variant='h5' sx={{ mb: 2, textAlign: 'center' }}>
        Review Your Information
      </Typography>

      {Object.entries(sections).map(([sectionTitle, fields]) => (
        <Box key={sectionTitle} sx={{ mb: 3, 'overflow-wrap': 'break-word' }}>
          <Typography variant='h6' sx={{ mb: 1, fontWeight: 'bold' }}>
            {sectionTitle}
          </Typography>
          <Divider sx={{ mb: 2 }} />
          {fields.map(field => {
            const label = fieldLabels[field]
            return (
              <Typography key={field} sx={{ mb: 1 }}>
                <strong>{label}: </strong>{formatValue(field, formData[field])}
              </Typography>
            )
          })}
        </Box>
      ))}

      <Typography sx={{ mt: 2, fontStyle: 'italic', textAlign: 'left' }} color='textSecondary'>
        Please ensure all details are correct before submitting.
      </Typography>
    </Paper>
  )
}

export default SummaryPage
